import { useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { Menu, LogOut, Zap } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BrandMark } from "@/components/BrandMark";
import { QuickOuting } from "@/components/QuickOuting";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const TABS = [
  { to: "/", label: "Planner", id: "planner", end: true },
  { to: "/plans", label: "My Plans", id: "my-plans", end: true },
  { to: "/outings", label: "My Outings", id: "my-outings" },
  { to: "/deals", label: "Local Deals", id: "deals" },
  { to: "/friends", label: "Friends & Privacy", id: "friends" },
  { to: "/profile", label: "Taste Profile", id: "taste-profile" },
  { to: "/vision", label: "Vision", id: "vision" },
];
const BIZ_TABS = [{ to: "/business", label: "Business dashboard", id: "business" }, { to: "/vision", label: "Vision", id: "vision" }];
const ADMIN_TAB = { to: "/admin/ads", label: "Ad review", id: "admin-ads" };

const tabsFor = (user) => {
  if (!user) return TABS.filter((t) => t.id === "vision");
  if (user.role === "business") return BIZ_TABS;
  return user.role === "admin" ? [...TABS, ADMIN_TAB] : TABS;
};

const linkCls = ({ isActive }) =>
  `px-3 py-2 rounded-lg text-sm font-semibold transition-colors duration-150 ${isActive ? "bg-[#EAF4EC] text-[#23603F]" : "text-stone-600 hover:text-stone-900 hover:bg-stone-100"}`;

export const Nav = () => {
  const { user, logout } = useAuth();
  const [quick, setQuick] = useState(false);
  const nav = useNavigate();
  const tabs = tabsFor(user);
  const member = user && user.role !== "business";

  return (
    <header className="fixed top-0 inset-x-0 z-[1100] h-16 bg-[#F3F6EF]/85 backdrop-blur-md border-b border-stone-200/80">
      <div className="h-full px-4 lg:px-6 flex items-center gap-4">
        <Link to="/" data-testid="nav-brand-logo" className="flex items-center gap-2.5 shrink-0">
          <BrandMark size={34} testId="nav-brand-mark" />
          <span className="font-heading text-xl font-extrabold tracking-tight text-stone-900" style={{ fontFamily: "Outfit" }}>Outbound</span>
        </Link>
        <nav className="hidden 2xl:flex items-center gap-1 ml-4">
          {tabs.map((t) => (
            <NavLink key={t.id} to={t.to} end={t.end} className={linkCls} data-testid={`nav-tab-${t.id}`}>{t.label}</NavLink>
          ))}
        </nav>
        <div className="ml-auto flex items-center gap-2">
          {user ? (
            <>
              {member && <button data-testid="btn-quick-im-free-now" onClick={() => setQuick(true)}
                className="pulse-soft flex items-center gap-2 bg-[#2F7D55] hover:bg-[#23603F] text-white font-bold px-4 py-2 rounded-xl transition-colors duration-150 active:scale-95">
                <Zap className="w-4 h-4" /> I'm free now
              </button>}
              <button data-testid="nav-logout-btn" onClick={async () => { await logout(); nav("/login"); }}
                className="hidden 2xl:flex items-center gap-1.5 text-sm text-stone-500 hover:text-stone-900 px-2 py-2">
                <LogOut className="w-4 h-4" /> {user.name}
              </button>
            </>
          ) : (
            <Link to="/login" data-testid="nav-login-link" className="text-sm font-semibold text-[#23603F] px-3 py-2">Log in</Link>
          )}
          <DropdownMenu>
            <DropdownMenuTrigger data-testid="nav-mobile-menu" className="2xl:hidden p-2 rounded-lg hover:bg-stone-100"><Menu className="w-5 h-5" /></DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="z-[1200] w-56">
              {tabs.map((t) => (
                <DropdownMenuItem key={t.id} onClick={() => nav(t.to)} data-testid={`nav-mobile-${t.id}`}>{t.label}</DropdownMenuItem>
              ))}
              {user && <DropdownMenuItem onClick={async () => { await logout(); nav("/login"); }} data-testid="nav-mobile-logout">Log out</DropdownMenuItem>}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      {member && <QuickOuting open={quick} onOpenChange={setQuick} />}
    </header>
  );
};
